import { z } from 'zod';
export const rejectCompanySchema = z.object({
    reason: z.string().trim().min(3).max(500),
});
export const companyProfileSchema = z.object({
    raisonSociale: z.string().trim().min(2).max(200),
    codeApe: z
        .string()
        .trim()
        .regex(/^\d{4}[A-Z]$/)
        .optional()
        .or(z.literal('')),
    taille: z.enum(['1-10', '11-50', '51-200', '201-500', '500+']).optional(),
    adresse: z.string().trim().max(300).optional(),
    ville: z.string().trim().max(100).optional(),
    codePostal: z
        .string()
        .trim()
        .regex(/^\d{5}$/)
        .optional()
        .or(z.literal('')),
    pays: z.string().trim().max(80).default('France'),
    siteWeb: z.string().url().optional().or(z.literal('')),
    description: z.string().max(2000).optional(),
    sectorIds: z.array(z.string().uuid()).min(1).max(13),
    targetLevels: z.array(z.enum(['L3', 'M1', 'M2'])).min(1),
});
export const candidateSearchSchema = z.object({
    formationIds: z.array(z.string().uuid()).optional(),
    sectorIds: z.array(z.string().uuid()).optional(),
    levels: z.array(z.enum(['L3', 'M1', 'M2'])).optional(),
    langues: z.array(z.string()).optional(),
    mobilites: z.array(z.string()).optional(),
    motsCles: z.string().trim().max(200).optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(50).default(20),
});
//# sourceMappingURL=company.js.map